module.exports = __webpack_public_path__ + "img/mappy.png";